<template lang="html">
  <div>
    <b-button-group vertical>
      <b-button
        v-for="item in options"
        :key="'option_' + item.value"
        v-b-tooltip.hover.righttop.ds500
        :title="item.text"
        :variant="returnVariant(item)"
        class="remove-focus-outline"
        @click="changeTool(item)"
      >
        <v-icon :name="item.icon" />
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
/*
overlay_tool_options: [
  { text: "Move", value: "move", icon: "mouse-pointer" },
  { text: "Text", value: "text", icon: "i-cursor" },
  { text: "Rectangle", value: "rect", icon: "square" },
  { text: "Circle", value: "circle", icon: "circle" }
]
*/
export default {
  name: "VerticalButtons",
  props: {
    value: {
      type: String,
      default: () => ""
    },
    label: {
      type: String,
      default: () => ""
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    returnVariant(item) {
      if (item.value == this.value) {
        return "secondary";
      } else {
        return "outline-secondary";
      }
    },
    changeTool(item) {
      this.$store.commit("overlays/setOverlayToolValue", item.value);
    }
  }
};
</script>

<style lang="css" scoped>
.remove-focus-outline {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
